import React from 'react';
import './css/login.css';

import ellipse from '../images/ellipse.png'
import loginLogo from '../images/logo1.png'

const LoginForm = () => {
    return (
        <form className="login_form">
            <label>Email Address</label>
            <input className="login_form_field" type="text" placeholder="careplus@gmail.com"></input><br />
            <br />
            <label>Password</label>
            <input className="login_form_field" type="password" placeholder="at least six characters."></input><br />
            <br />
            <label className="artificial_checkbox">
                <input type='checkbox' />
                <span>&#10003;</span>
                Keep me logged in.
            </label>
            <br />
            <br />
            <input className="login_form_submit button_press" type="submit" value="Login"></input><br />
            <br />
        </form>
    )
}

const FormContainer = () => {
    return (
        <div>
        <div>
            <img className="login_logo_ellipse" src={ellipse} alt="elli" />
            <a href="./"><img className="login_logo" src={loginLogo} alt="logo" /></a>
        </div>
        <div className="form_container">
            <h1 className="form_header">Login</h1>
            <h3 className="form_text">Welcome back! Login to your CarePlus account by entering your details.</h3>
            <p className="login_error_message">* Incorrect Email or Password!</p>
            <br />
            <LoginForm />
            <br />
            <span className="signup_invite">Not registered yet? <a href="./">Sign Up.</a></span>
            <span className="forgot_password"><a href="./">Forgot Password?</a></span>
            <br /><br />
        </div>
        </div>
    )
}

export default FormContainer;